﻿<script setup lang="ts">
    import BSFormInputText from '@shared/components/BSFormInputText.vue';
    import BSFormInputTextarea from '@shared/components/BSFormInputTextarea.vue';
    import InputCheckbox from '@shared/components/InputCheckbox.vue';

    type SettingsProps = {
        active: boolean;
        name: string | null;
        description: string | null;
    };

    const props = defineProps<SettingsProps>();
</script>

<script lang="ts"></script>

<template>
    <fieldset class="fieldset">
        <legend>{{ $Resources.MediaMonitorGeneralSettingsHeading }}</legend>
        <p class="m-lg-b">{{ $Resources.MediaMonitorRequiredInfo }}</p>

        <BSFormInputText
            class="form-group"
            :modelValue="props.name"
            @update:modelValue="(newValue: string) => $emit('update:name', newValue)"
            :required="true"
            :label="$Resources.MediaMonitorNameLabel"></BSFormInputText>

        <BSFormInputTextarea
            class="form-group"
            :modelValue="props.description"
            @update:modelValue="(newValue: string) => $emit('update:description', newValue)"
            :rows="3"
            :label="$Resources.MediaMonitorDescriptionLabel"></BSFormInputTextarea>

        <div class="form-group">
            <InputCheckbox :checked="props.active" @update:checked="(newValue: boolean) => $emit('update:active', newValue)">
                <template #label>{{ $Resources.MediaMonitorActiveLabel }}</template>
            </InputCheckbox>
        </div>
    </fieldset>
</template>

<style lang="less"></style>

<style scoped lang="less"></style>
